
import { useState } from "react";
import { Header } from "../components/Header";
import { StoryCard } from "../components/StoryCard";
import { stories, categories } from "../data/stories";
import { Badge } from "@/components/ui/badge";

const Index = () => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

  const filteredStories = selectedCategory
    ? stories.filter(story => story.category === selectedCategory)
    : stories;

  return (
    <div className="min-h-screen bg-[#F5E6D3]">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <div className="relative mb-12">
          <div 
            className="absolute inset-0 bg-cover bg-center z-0"
            style={{
              backgroundImage: "url('/lovable-uploads/c0877c2f-ca89-446b-b00b-0dc22e963a33.png')",
              filter: "brightness(0.9)",
            }}
          />
          <div className="relative z-10 flex justify-between items-center py-12 bg-black/30 rounded-lg px-8">
            <div className="text-xl text-white">New Stories Every Month!</div>
            <div className="text-right">
              <h1 className="text-4xl font-bold text-white">Coming Soon</h1>
              <p className="text-xl text-white">The Adventures of Inspector Toussaint Clark</p>
            </div>
          </div>
        </div>
        
        <h1 className="text-3xl font-bold mb-2 text-[#2C1810]">Featured Stories</h1>
        <p className="text-sm mb-8 text-[#594A42]">(all rights reserved)</p>
        
        <div className="flex flex-wrap gap-3 mb-8">
          <Badge
            onClick={() => setSelectedCategory(null)}
            className={`cursor-pointer hover:bg-[#D46F4D] text-base px-5 py-2 ${
              selectedCategory === null ? 'bg-[#D46F4D]' : 'bg-[#8B6D63]'
            }`}
          >
            All
          </Badge>
          {categories.map((category) => (
            <Badge
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`cursor-pointer hover:bg-[#D46F4D] text-base px-5 py-2 ${
                selectedCategory === category ? 'bg-[#D46F4D]' : 'bg-[#8B6D63]'
              }`}
            >
              {category}
            </Badge>
          ))}
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {filteredStories.map((story, index) => (
            <StoryCard
              key={story.id}
              id={story.id}
              title={story.title}
              excerpt={story.excerpt}
              author={story.author}
              date={story.date}
              isNewest={index === 0} // First story is the newest since they're already sorted by date
            />
          ))}
        </div>
      </main>
    </div>
  );
};

export default Index;
